module.exports = __webpack_public_path__ + "static/media/Eggplant.9374fe09.webp";